/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./safety-webview.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./safety-webview.component";
import * as i3 from "@angular/router";
var styles_SafetyWebview = [i0.styles];
var RenderType_SafetyWebview = i1.ɵcrt({ encapsulation: 0, styles: styles_SafetyWebview, data: {} });
export { RenderType_SafetyWebview as RenderType_SafetyWebview };
export function View_SafetyWebview_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), i1.ɵeld(1, 0, null, null, 0, "img", [["alt", "Page Not Found"], ["class", "imageUrl"]], [[8, "src", 4]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = i1.ɵinlineInterpolate(1, "", _co.pageUrl, ""); _ck(_v, 1, 0, currVal_0); }); }
export function View_SafetyWebview_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "safety", [], null, null, null, View_SafetyWebview_0, RenderType_SafetyWebview)), i1.ɵdid(1, 114688, null, 0, i2.SafetyWebview, [i3.ActivatedRoute], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SafetyWebviewNgFactory = i1.ɵccf("safety", i2.SafetyWebview, View_SafetyWebview_Host_0, {}, {}, []);
export { SafetyWebviewNgFactory as SafetyWebviewNgFactory };
